export const filters = `{
  title
  type
  full_key
  options
  values {
    title
    value
    extra_data
  }
}`